import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateSkill } from "../../api/apiSkills";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث مهارة
 */
export function useUpdateSkill() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateSkillMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateSkill(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
            navigate('/skills');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update skill");
        },
    });

    return {
        updateSkillMutate,
        isPending,
    };
}